export interface Segment<T extends string> {
  value: T;
  label: string;
}

export interface SegmentedControlProps<T extends string> {
  value: T;
  options: Segment<T>[];
  onChange: (value: T) => void;
  label: string;
}

/** The equal / exact toggle from the prototype. */
export function SegmentedControl<T extends string>({
  value,
  options,
  onChange,
  label,
}: SegmentedControlProps<T>) {
  return (
    <div
      role="radiogroup"
      aria-label={label}
      style={{
        display: 'flex',
        padding: 4,
        gap: 4,
        background: 'var(--surface)',
        border: '1px solid var(--border)',
        borderRadius: 'var(--r-lg)',
      }}
    >
      {options.map((option) => {
        const selected = option.value === value;
        return (
          <button
            key={option.value}
            type="button"
            role="radio"
            aria-checked={selected}
            onClick={() => onChange(option.value)}
            style={{
              flex: 1,
              borderRadius: 'var(--r-sm)',
              border: 'none',
              padding: '10px 0',
              fontSize: 'var(--fs-body-md)',
              fontWeight: selected ? 600 : 400,
              background: selected ? 'var(--accent)' : 'transparent',
              color: selected ? '#fff' : 'var(--text-secondary)',
              cursor: 'pointer',
              transition: 'background 120ms ease, color 120ms ease',
            }}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}
